module.exports = __webpack_public_path__ + "static/media/assignTasks@3x.9213c80b.png";